import { addToCart } from '../cart/add-cart'
import { productChangeVariants } from './product-change-variants'

const $win = $(window)
const $doc = $(document)

// Product Btn - Add to Cart
$doc.on('click', '.js-product-btn', function (e) {
  e.preventDefault()

  const $this = $(this)
  const $form = $this.closest('form')

  addToCart($form, true)
})

$doc.on('click', '.js-product-options a', function (e) {
  e.preventDefault()
  const $this = $(this)
  const $form = $this.closest('form')
  const $product = $this.closest('.js-product')

  $this
    .closest('li')
    .addClass('is-current')
    .siblings()
    .removeClass('is-current')

  productChangeVariants($this, $form, $product)
})
